import { types } from 'mobx-state-tree';
import HistoryStore from './history';

const WindowInfo = types
    .model('WindowInfo', {
        minimized: types.boolean,
        maximized: types.boolean,
        closed: types.boolean, 
        x: types.optional(types.integer, 0),
        y: types.optional(types.integer, 0),
        width: types.optional(types.integer, 0),
        height: types.optional(types.integer, 0),
        history: types.optional(HistoryStore, {}),
    })
    .actions(self => ({
        updateMiminize(val: boolean) {
            self.minimized = val;
        },
        updateMaximize(val: boolean) {
            self.maximized = val;
        },
        updateClose(val: boolean) {
            self.closed = val;
        }
    }));

export default WindowInfo;
